import FeatureDetailsTexts from "@/v2-backoffice-client/feature/details/FeatureDetailsTexts"
import LayerViewDetailsExtras from "@/v2-backoffice-client/layer/view/LayerViewDetailsExtras"
import LayerViewDetailsHotfixTexts from "@/v2-backoffice-client/layer/view/LayerViewDetailsHotfixTexts"
import LayerSublayerManager from "@/v2-backoffice-client/layer/sublayer/LayerSublayerManager"
import { IS_CATALOG_AUTHORING_ENABLED } from "@/v2-backoffice-client/feature/feature.constants"
import type { LayerFragment } from "@/v2-backoffice-client/layer/__types__/layer.fragment"

export type LayerViewDetailsProps = {
  layer: LayerFragment
}

/**
 * Details form of the layer sheet: what the layer IS — its name/description
 * in every supported language, the thumbnail, the declared freshness and
 * its sublayers. Who sees it (publish state, countries, access, categories)
 * is the Availability tab.
 *
 * The text block IS the Translation page's editor (TranslationEditor),
 * scoped to this one layer's feature code — same fields, same AI actions,
 * same history, and the exact same pipeline: saves land in the translation
 * catalog, appear under Translation → Review pending, and go live with the
 * next translation publish. Layers are excluded from the Translation tab's
 * own catalog list, so this embed is their one text-editing surface.
 */
function LayerViewDetails(props: LayerViewDetailsProps) {
  const { layer } = props

  return (
    <div className="layer-view-details flex flex-col gap-6 pt-2">
      <LayerViewDetailsExtras layer={layer} />

      {IS_CATALOG_AUTHORING_ENABLED ? (
        <FeatureDetailsTexts
          featureCode={layer.FeatureCode}
          subject="layer"
          featureCodeLabel="Layers"
        />
      ) : (
        <LayerViewDetailsHotfixTexts layer={layer} />
      )}

      {IS_CATALOG_AUTHORING_ENABLED && (
        <LayerSublayerManager layerFeatureCode={layer.FeatureCode} />
      )}
    </div>
  )
}

export default LayerViewDetails
